import React, { SetStateAction, useContext, useEffect } from "react";
import { useState } from "react";
import { Checkbox, FormControlLabel, Stack, Typography, } from "@mui/material";
import { Paper, TableBody } from "@mui/material";
import { TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import { StyledTableCell, StyledTableHead, } from "../../../Styles/tabelCellStyled/customTableCell";
import { CustomSelect, CustomTextField, CustomThemeProvider, } from "../../../Styles/theme/customThemeprovider";
import BasicPopover from "../../../Components/Popover";
import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { del, get, post } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import { IAnaliseTerras } from "../../../Interfaces/cadernos/caderno5/interfaces5B";
import { classeFertilizacao } from "../../../informacao_estatica";
import { formatarNumero_ao_digitar, desformatarNumero } from "../../../Func_genericas/formatar_numero_formato_pt";
import LoadingVulpes from "../../../Styles/Loader/loading";
import { formatar_numeros_Analise_Terra_5B } from "../../../Componentes_modulo/FuncoesFormatarNumeroPT/cadernos/caderno5B";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { mensagem_tem_a_certeza_de_apagar_alteracoes, message_apenas_numero } from "../../../Func_genericas/valores_estaticos";
import { useLocation } from "react-router-dom";

interface IAnaliseTerrasProps {
  setOpenSnackSuccess: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenSnackError: React.Dispatch<React.SetStateAction<boolean>>;
  setMessage: React.Dispatch<SetStateAction<string>>
  idCabecalho: number;
}

export const AnaliseTerrasForm: React.FC<IAnaliseTerrasProps> = ({
  setOpenSnackSuccess,
  setOpenSnackError,
  setMessage,
  idCabecalho
}) => {
  const auth = useContext(AuthContext);
  const location = useLocation();
  const is_historico = location.state?.is_historico ?? false;

  const [createTable, setCreateTable] = useState<boolean>(false);
  const [openDeleteAnalise, setOpenDeleteAnalise] = React.useState(false);
  const [editRow, setEditRow] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  // Estado para a Tabela Análise da terra
  const [rowsTableTerra, setRowsTabelaTerra] = useState<IAnaliseTerras[]>([]);
  const [tabelaTerra, setTabelaTerra] = useState<IAnaliseTerras | undefined>();

  const [error_mg_camp1, set_error_mg_camp1] = useState<boolean>(false);
  const [error_mg_camp2, set_error_mg_camp2] = useState<boolean>(false);
  const [error_mg_camp3, set_error_mg_camp3] = useState<boolean>(false);
  const [error_mg_camp4, set_error_mg_camp4] = useState<boolean>(false);
  const [error_mg_camp5, set_error_mg_camp5] = useState<boolean>(false);
  const [error_mg_camp6, set_error_mg_camp6] = useState<boolean>(false);
  const [error_percentagem_camp1, set_error_percentagem_camp1] = useState<boolean>(false);
  const [error_percentagem_camp2, set_error_percentagem_camp2] = useState<boolean>(false);
  const [error_percentagem_camp3, set_error_percentagem_camp3] = useState<boolean>(false);
  const [error_percentagem_camp4, set_error_percentagem_camp4] = useState<boolean>(false);
  const [error_percentagem_camp5, set_error_percentagem_camp5] = useState<boolean>(false);
  const [error_percentagem_camp6, set_error_percentagem_camp6] = useState<boolean>(false);
  const [error_Resultados_analicesPH, set_error_Resultados_analicesPH] = useState<boolean>(false);
  const [error_Resultados_analicesMO, set_error_Resultados_analicesMO] = useState<boolean>(false);
  const [error_deduzir_cálculo, set_error_deduzir_cálculo] = useState<boolean>(false);
  const camposNumericos = [
    "percentagem_camp1",
    "percentagem_camp2",
    "percentagem_camp3",
    "percentagem_camp4",
    "percentagem_camp5",
    "percentagem_camp6",
    "resultados_analicesMO",
    "resultados_analicesPH",
    "mg_camp1", "mg_camp2", "mg_camp3", "mg_camp4", "mg_camp5", "mg_camp6",
    "deduzir_cálculo"];

  const [flag_editado, set_flag_editado] = React.useState(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);


  const handleCloseDialog = () => {
    set_error_mg_camp1(false)
    set_error_mg_camp2(false)
    set_error_mg_camp3(false)
    set_error_mg_camp4(false)
    set_error_mg_camp5(false)
    set_error_mg_camp6(false)
    set_error_percentagem_camp1(false)
    set_error_percentagem_camp2(false)
    set_error_percentagem_camp3(false)
    set_error_percentagem_camp4(false)
    set_error_percentagem_camp5(false)
    set_error_percentagem_camp6(false)
    set_error_Resultados_analicesPH(false)
    set_error_Resultados_analicesMO(false)
    set_error_deduzir_cálculo(false)

    setCreateTable(false);

    setEditRow(false)
    setTabelaTerra(undefined)
    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)

  };

  async function getAnalise() {
    try {
      setCreateTable(false);
      setIsLoading(true);
      let res = await get(auth.token.cookie_token, `/get_reg_actividades_cabecalho/${idCabecalho}`);
      if (res.status === 200) {
        const formattedData = res.data.result.map(formatar_numeros_Analise_Terra_5B);
        setRowsTabelaTerra(formattedData);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("getAnalise", error, true);
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    (async () => {
      await getAnalise();
    })();
  }, [idCabecalho]);

  const handleCancel = () => {
    setCreateTable(false);
    setEditRow(false);
    setTabelaTerra(undefined)
  }

  const onInputChange = (event: any) => {
    const { name, value, type } = event.target;
    set_flag_editado(true)
    let aux_obj_checked: any = tabelaTerra === undefined ? {} : tabelaTerra;

    if (type === "checkbox") {
      aux_obj_checked[name] = aux_obj_checked[name] === undefined ? true : !aux_obj_checked[name]

      setTabelaTerra((prev: any) => ({
        ...prev,
        [name]: aux_obj_checked[name] === undefined ? false : aux_obj_checked[name],
      }));

    } else {
      const isCampoNumerico = camposNumericos.includes(name);

      if (isCampoNumerico) {
        const valorSemFormatar = value.replace(/[^\d,]/g, "");
        const valorNumerico = parseFloat(value.replace(",", "."));

        if (!isNaN(valorNumerico)) {
          if (name === "percentagem_camp1") {
            set_error_percentagem_camp1(false);
          } else if (name === "percentagem_camp2") {
            set_error_percentagem_camp2(false);
          } else if (name === "percentagem_camp3") {
            set_error_percentagem_camp3(false);
          } else if (name === "percentagem_camp4") {
            set_error_percentagem_camp4(false);
          } else if (name === "percentagem_camp5") {
            set_error_percentagem_camp5(false);
          } else if (name === "percentagem_camp6") {
            set_error_percentagem_camp6(false);
          } else if (name === "classe_analicesMO") {
            set_error_Resultados_analicesMO(false);
          } else if (name === "classe_analicesPH") {
            set_error_Resultados_analicesPH(false);
          } else if (name === "deduzir_cálculo") {
            set_error_deduzir_cálculo(false);
          } else if (name === "mg_camp1") {
            set_error_mg_camp1(false);
          } else if (name === "mg_camp2") {
            set_error_mg_camp2(false);
          } else if (name === "mg_camp3") {
            set_error_mg_camp3(false);
          } else if (name === "mg_camp4") {
            set_error_mg_camp4(false);
          } else if (name === "mg_camp5") {
            set_error_mg_camp5(false);
          } else if (name === "mg_camp6") {
            set_error_mg_camp6(false);
          }
        } else {
          if (name === "percentagem_camp1") {
            set_error_percentagem_camp1(true);
          } else if (name === "percentagem_camp2") {
            set_error_percentagem_camp2(true);
          } else if (name === "percentagem_camp3") {
            set_error_percentagem_camp3(true);
          } else if (name === "percentagem_camp4") {
            set_error_percentagem_camp4(true);
          } else if (name === "percentagem_camp5") {
            set_error_percentagem_camp5(true);
          } else if (name === "percentagem_camp6") {
            set_error_percentagem_camp6(true);
          } else if (name === "classe_analicesMO") {
            set_error_Resultados_analicesMO(true);
          } else if (name === "classe_analicesPH") {
            set_error_Resultados_analicesPH(true);
          } else if (name === "deduzir_cálculo") {
            set_error_deduzir_cálculo(true);
          } else if (name === "mg_camp1") {
            set_error_mg_camp1(true);
          } else if (name === "mg_camp2") {
            set_error_mg_camp2(true);
          } else if (name === "mg_camp3") {
            set_error_mg_camp3(true);
          } else if (name === "mg_camp4") {
            set_error_mg_camp4(true);
          } else if (name === "mg_camp5") {
            set_error_mg_camp5(true);
          } else if (name === "mg_camp6") {
            set_error_mg_camp6(true);
          }
        }
        setTabelaTerra((prevAnaliseTerrras: any) => ({
          ...prevAnaliseTerrras,
          [name]: formatarNumero_ao_digitar(valorSemFormatar),
        }));
      } else {
        setTabelaTerra((prevAnaliseTerrras: any) => ({
          ...prevAnaliseTerrras,
          [name]: value,
        }));
      }
    }

  };

  const handleSaveAnalise = async () => {
    func_print("tabelaTerra passou aqui", tabelaTerra)
    if (tabelaTerra === undefined) {
      setMessage("Preencha a tabela antes de gravar");
      setOpenSnackError(true);
    } else try {
      setIsLoading(true);
      let res = await post(auth.token.cookie_token, "new_reg_actividades", {
        payload: {
          id_registo_analise: 0,
          cabe_opcao_um: tabelaTerra?.cabe_opcao_um === undefined ? null : tabelaTerra.cabe_opcao_um,
          cabe_opcao_dois: tabelaTerra?.cabe_opcao_dois === undefined ? null : tabelaTerra.cabe_opcao_dois,
          mg_camp1: tabelaTerra?.mg_camp1 === undefined ? null : desformatarNumero(tabelaTerra.mg_camp1),
          mg_camp2: tabelaTerra?.mg_camp2 === undefined ? null : desformatarNumero(tabelaTerra.mg_camp2),
          mg_camp3: tabelaTerra?.mg_camp3 === undefined ? null : desformatarNumero(tabelaTerra.mg_camp3),
          mg_camp4: tabelaTerra?.mg_camp4 === undefined ? null : desformatarNumero(tabelaTerra.mg_camp4),
          mg_camp5: tabelaTerra?.mg_camp5 === undefined ? null : desformatarNumero(tabelaTerra.mg_camp5),
          mg_camp6: tabelaTerra?.mg_camp6 === undefined ? null : desformatarNumero(tabelaTerra.mg_camp6),
          percentagem_camp1: tabelaTerra?.percentagem_camp1 === undefined ? null : desformatarNumero(tabelaTerra.percentagem_camp1),
          percentagem_camp2: tabelaTerra?.percentagem_camp2 === undefined ? null : desformatarNumero(tabelaTerra.percentagem_camp2),
          percentagem_camp3: tabelaTerra?.percentagem_camp3 === undefined ? null : desformatarNumero(tabelaTerra.percentagem_camp3),
          percentagem_camp4: tabelaTerra?.percentagem_camp4 === undefined ? null : desformatarNumero(tabelaTerra.percentagem_camp4),
          percentagem_camp5: tabelaTerra?.percentagem_camp5 === undefined ? null : desformatarNumero(tabelaTerra.percentagem_camp5),
          percentagem_camp6: tabelaTerra?.percentagem_camp6 === undefined ? null : desformatarNumero(tabelaTerra.percentagem_camp6),
          classe_analicesPH: tabelaTerra?.classe_analicesPH === undefined ? null : desformatarNumero(tabelaTerra.classe_analicesPH),
          classe_analicesMO: tabelaTerra?.classe_analicesMO === undefined ? null : desformatarNumero(tabelaTerra.classe_analicesMO),

          classe_fertilizacao_camp1: tabelaTerra?.classe_fertilizacao_camp1 === undefined ? null : tabelaTerra.classe_fertilizacao_camp1,
          classe_fertilizacao_camp2: tabelaTerra?.classe_fertilizacao_camp2 === undefined ? null : tabelaTerra.classe_fertilizacao_camp2,
          classe_fertilizacao_camp3: tabelaTerra?.classe_fertilizacao_camp3 === undefined ? null : tabelaTerra.classe_fertilizacao_camp3,
          classe_fertilizacao_camp4: tabelaTerra?.classe_fertilizacao_camp4 === undefined ? null : tabelaTerra.classe_fertilizacao_camp4,
          classe_fertilizacao_camp5: tabelaTerra?.classe_fertilizacao_camp5 === undefined ? null : tabelaTerra.classe_fertilizacao_camp5,
          classe_fertilizacao_camp6: tabelaTerra?.classe_fertilizacao_camp6 === undefined ? null : tabelaTerra.classe_fertilizacao_camp6,
          classe_fertilizacao_camp7: tabelaTerra?.classe_fertilizacao_camp7 === undefined ? null : tabelaTerra.classe_fertilizacao_camp7,
          classe_fertilizacao_camp8: tabelaTerra?.classe_fertilizacao_camp8 === undefined ? null : tabelaTerra.classe_fertilizacao_camp8,

          deduzir_cálculo: tabelaTerra?.deduzir_cálculo === undefined ? null : desformatarNumero(tabelaTerra.deduzir_cálculo),
          deduzir_cálculo_camp2: tabelaTerra?.deduzir_cálculo_camp2 === undefined ? null : desformatarNumero(tabelaTerra.deduzir_cálculo_camp2),
          azoto_mineral: tabelaTerra?.azoto_mineral === undefined ? false : tabelaTerra.azoto_mineral,
          azoto_nitrico: tabelaTerra?.azoto_nitrico === undefined ? false : tabelaTerra.azoto_nitrico,
          azoto_total: tabelaTerra?.azoto_total === undefined ? false : tabelaTerra.azoto_total,

          id_registo_activi: idCabecalho,
          last_update: new Date().toISOString(),
          create_date: new Date().toISOString(),
          uuid: ""
        }
      });

      if (res.status === 200) {
        setMessage("Gravado com sucesso!");
        setCreateTable(false);
        setRowsTabelaTerra((prevRows) => {
          return [...prevRows, formatar_numeros_Analise_Terra_5B(res.data.result)]
        });
        setTabelaTerra(undefined);
        setOpenSnackSuccess(true);
        setCreateTable(false);
        set_error_mg_camp1(false)
        set_error_mg_camp2(false)
        set_error_mg_camp3(false)
        set_error_mg_camp4(false)
        set_error_mg_camp5(false)
        set_error_mg_camp6(false)
        set_error_percentagem_camp1(false)
        set_error_percentagem_camp2(false)
        set_error_percentagem_camp3(false)
        set_error_percentagem_camp4(false)
        set_error_percentagem_camp5(false)
        set_error_percentagem_camp6(false)
        set_error_Resultados_analicesPH(false)
        set_error_Resultados_analicesMO(false)
        set_error_deduzir_cálculo(false)
      } else {
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error: any) {
      func_print("handleSaveAnalise", error, true);
      // if (error?.status === 409) {

      //   setMessage(error?.response.data.detail);
      //   setOpenSnackError(true);
      // } else {
      //   setMessage("Erro ao efetuar a sua operação!");
      //   setOpenSnackError(true);
      // }
      if ((error as any)?.response?.data?.message) {
        setMessage((error as any).response.data.message);
      } else {
        setMessage("Erro ao efetuar a sua operação!");
      }
      setOpenSnackError(true);

      setIsLoading(false);
    }
  };

  // EDITAR
  const handleEdit = (obj: IAnaliseTerras) => {
    setTabelaTerra(obj);

    setEditRow(true);
  };

  const onInputChange_editar = (event: any) => {
    const { name, value, type, checked } = event.target;

    const isCampoNumerico = camposNumericos.includes(name);
    set_flag_editado(true)


    if (isCampoNumerico) {

      const valorSemFormatar = value.replace(/[^\d,]/g, "");
      func_print('valorSemFormatar', valorSemFormatar)
      const valorNumerico = parseFloat(value.replace(",", "."));
      func_print('valorNumerico', valorNumerico)

      if (!isNaN(valorNumerico)) {
        if (name === "percentagem_camp1") {
          set_error_percentagem_camp1(false);
        } else if (name === "percentagem_camp2") {
          set_error_percentagem_camp2(false);
        } else if (name === "percentagem_camp3") {
          set_error_percentagem_camp3(false);
        } else if (name === "percentagem_camp4") {
          set_error_percentagem_camp4(false);
        } else if (name === "percentagem_camp5") {
          set_error_percentagem_camp5(false);
        } else if (name === "percentagem_camp6") {
          set_error_percentagem_camp6(false);
        } else if (name === "resultados_analicesMO") {
          set_error_Resultados_analicesMO(false);
        } else if (name === "resultados_analicesPH") {
          set_error_Resultados_analicesPH(false);
        } else if (name === "deduzir_cálculo") {
          set_error_deduzir_cálculo(false);
        } else if (name === "mg_camp1") {
          set_error_mg_camp1(false);
        } else if (name === "mg_camp2") {
          set_error_mg_camp2(false);
        } else if (name === "mg_camp3") {
          set_error_mg_camp3(false);
        } else if (name === "mg_camp4") {
          set_error_mg_camp4(false);
        } else if (name === "mg_camp5") {
          set_error_mg_camp5(false);
        } else if (name === "mg_camp6") {
          set_error_mg_camp6(false);
        }
      } else {
        if (name === "percentagem_camp1") {
          set_error_percentagem_camp1(true);
        } else if (name === "percentagem_camp2") {
          set_error_percentagem_camp2(true);
        } else if (name === "percentagem_camp3") {
          set_error_percentagem_camp3(true);
        } else if (name === "percentagem_camp4") {
          set_error_percentagem_camp4(true);
        } else if (name === "percentagem_camp5") {
          set_error_percentagem_camp5(true);
        } else if (name === "percentagem_camp6") {
          set_error_percentagem_camp6(true);
        } else if (name === "resultados_analicesMO") {
          set_error_Resultados_analicesMO(true);
        } else if (name === "resultados_analicesPH") {
          set_error_Resultados_analicesPH(true);
        } else if (name === "deduzir_cálculo") {
          set_error_deduzir_cálculo(true);
        } else if (name === "mg_camp1") {
          set_error_mg_camp1(true);
        } else if (name === "mg_camp2") {
          set_error_mg_camp2(true);
        } else if (name === "mg_camp3") {
          set_error_mg_camp3(true);
        } else if (name === "mg_camp4") {
          set_error_mg_camp4(true);
        } else if (name === "mg_camp5") {
          set_error_mg_camp5(true);
        } else if (name === "mg_camp6") {
          set_error_mg_camp6(true);
        }
      }
      setTabelaTerra((prevExtraRow: any) => ({
        ...prevExtraRow,
        [name]: formatarNumero_ao_digitar(valorSemFormatar)
      }));
    } else {
      setTabelaTerra((prevExtraRow: any) => ({
        ...prevExtraRow,
        [name]: value,
      }));
    }


  };

  const handleUpdateAnalise = async () => {
    try {

      setIsLoading(true);
      let res = await post(auth.token.cookie_token, "update_reg_actividades", {
        payload: {
          id_registo_analise: tabelaTerra?.id_registo_analise,
          cabe_opcao_um: tabelaTerra?.cabe_opcao_um === undefined ? null : tabelaTerra.cabe_opcao_um,
          cabe_opcao_dois: tabelaTerra?.cabe_opcao_dois === undefined ? null : tabelaTerra.cabe_opcao_dois,
          mg_camp1: tabelaTerra?.mg_camp1 === undefined ? null : desformatarNumero(tabelaTerra.mg_camp1),
          mg_camp2: tabelaTerra?.mg_camp2 === undefined ? null : desformatarNumero(tabelaTerra.mg_camp2),
          mg_camp3: tabelaTerra?.mg_camp3 === undefined ? null : desformatarNumero(tabelaTerra.mg_camp3),
          mg_camp4: tabelaTerra?.mg_camp4 === undefined ? null : desformatarNumero(tabelaTerra.mg_camp4),
          mg_camp5: tabelaTerra?.mg_camp5 === undefined ? null : desformatarNumero(tabelaTerra.mg_camp5),
          mg_camp6: tabelaTerra?.mg_camp6 === undefined ? null : desformatarNumero(tabelaTerra.mg_camp6),
          percentagem_camp1: tabelaTerra?.percentagem_camp1 === undefined ? null : desformatarNumero(tabelaTerra.percentagem_camp1),
          percentagem_camp2: tabelaTerra?.percentagem_camp2 === undefined ? null : desformatarNumero(tabelaTerra.percentagem_camp2),
          percentagem_camp3: tabelaTerra?.percentagem_camp3 === undefined ? null : desformatarNumero(tabelaTerra.percentagem_camp3),
          percentagem_camp4: tabelaTerra?.percentagem_camp4 === undefined ? null : desformatarNumero(tabelaTerra.percentagem_camp4),
          percentagem_camp5: tabelaTerra?.percentagem_camp5 === undefined ? null : desformatarNumero(tabelaTerra.percentagem_camp5),
          percentagem_camp6: tabelaTerra?.percentagem_camp6 === undefined ? null : desformatarNumero(tabelaTerra.percentagem_camp6),
          classe_analicesPH: tabelaTerra?.classe_analicesPH === undefined ? null : desformatarNumero(tabelaTerra.classe_analicesPH),
          classe_analicesMO: tabelaTerra?.classe_analicesMO === undefined ? null : desformatarNumero(tabelaTerra.classe_analicesMO),
          classe_fertilizacao_camp1: tabelaTerra?.classe_fertilizacao_camp1 === undefined ? null : tabelaTerra.classe_fertilizacao_camp1,
          classe_fertilizacao_camp2: tabelaTerra?.classe_fertilizacao_camp2 === undefined ? null : tabelaTerra.classe_fertilizacao_camp2,
          classe_fertilizacao_camp3: tabelaTerra?.classe_fertilizacao_camp3 === undefined ? null : tabelaTerra.classe_fertilizacao_camp3,
          classe_fertilizacao_camp4: tabelaTerra?.classe_fertilizacao_camp4 === undefined ? null : tabelaTerra.classe_fertilizacao_camp4,
          classe_fertilizacao_camp5: tabelaTerra?.classe_fertilizacao_camp5 === undefined ? null : tabelaTerra.classe_fertilizacao_camp5,
          classe_fertilizacao_camp6: tabelaTerra?.classe_fertilizacao_camp6 === undefined ? null : tabelaTerra.classe_fertilizacao_camp6,
          classe_fertilizacao_camp7: tabelaTerra?.classe_fertilizacao_camp7 === undefined ? null : tabelaTerra.classe_fertilizacao_camp7,
          classe_fertilizacao_camp8: tabelaTerra?.classe_fertilizacao_camp8 === undefined ? null : tabelaTerra.classe_fertilizacao_camp8,
          deduzir_cálculo: tabelaTerra?.deduzir_cálculo === undefined ? null : desformatarNumero(tabelaTerra.deduzir_cálculo),
          deduzir_cálculo_camp2: tabelaTerra?.deduzir_cálculo_camp2 === undefined ? null : tabelaTerra.deduzir_cálculo_camp2,
          azoto_mineral: tabelaTerra?.azoto_mineral === undefined ? false : tabelaTerra.azoto_mineral,
          azoto_nitrico: tabelaTerra?.azoto_nitrico === undefined ? false : tabelaTerra.azoto_nitrico,
          azoto_total: tabelaTerra?.azoto_total === undefined ? false : tabelaTerra.azoto_total,
          id_registo_activi: tabelaTerra?.id_registo_activi,
          last_update: tabelaTerra?.last_update,
          create_date: tabelaTerra?.create_date,
          uuid: tabelaTerra?.uuid
        }
      });

      if (res.status === 200) {
        setMessage("Atualizado com sucesso!");
        setCreateTable(false);
        const updatedRows = rowsTableTerra.map((row) => {
          if (row.id_registo_analise === tabelaTerra?.id_registo_analise) {
            return formatar_numeros_Analise_Terra_5B(res.data.result)
          } else {
            return { ...row }
          }
        });
        setRowsTabelaTerra(updatedRows !== undefined ? updatedRows : []);
        setEditRow(false);
        setTabelaTerra(undefined);
        setOpenSnackSuccess(true);
        set_error_mg_camp1(false)
        set_error_mg_camp2(false)
        set_error_mg_camp3(false)
        set_error_mg_camp4(false)
        set_error_mg_camp5(false)
        set_error_mg_camp6(false)
        set_error_percentagem_camp1(false)
        set_error_percentagem_camp2(false)
        set_error_percentagem_camp3(false)
        set_error_percentagem_camp4(false)
        set_error_percentagem_camp5(false)
        set_error_percentagem_camp6(false)
        set_error_Resultados_analicesPH(false)
        set_error_Resultados_analicesMO(false)
        set_error_deduzir_cálculo(false)
      } else {
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error: any) {
      func_print("handleUpdate", error, true);
      if (error?.status === 409) {

        setMessage(error?.response.data.detail);
        setOpenSnackError(true);
      } else {
        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
      }

      setIsLoading(false);
    }

  };

  // Delete
  const handleClickOpenDelete = (obj: IAnaliseTerras) => {
    setTabelaTerra(obj);
    setOpenDeleteAnalise(true);
  };

  const handleDeleteAnalise = async () => {
    try {
      setIsLoading(true);
      let res = await del(auth.token.cookie_token, `/delete__reg_actividades/${tabelaTerra?.id_registo_analise}`);

      if (res.status === 200) {
        setMessage("Registo eliminado com sucesso!");
        setOpenDeleteAnalise(false);
        setTabelaTerra(undefined);
        setRowsTabelaTerra((oldRows) => [
          ...oldRows.filter((oldRow) => oldRow.id_registo_analise !== tabelaTerra?.id_registo_analise),
        ]);
        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao eliminar o registo!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleDeleteAnalise", error, true);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading ? (
        <LoadingVulpes />
      ) : (
        <CustomThemeProvider>
          <TableContainer
            component={Paper}
            variant="outlined"
            sx={{ height: "auto", width: "auto", margin: 2, padding: 2, }}
          >
            <table style={{ width: "100%" }}>
              <TableHead>
                <TableRow>
                  {rowsTableTerra.length <= 0 && (
                    <TableCell
                      colSpan={9}
                      sx={{ fontWeight: 600, textAlign: "left", fontFamily: "candara", fontSize: 18, }}
                    >
                      Resultados das análises da Terra
                    </TableCell>
                  )}

                  {rowsTableTerra.length <= 0 && createTable === false ? (
                    <TableCell>
                      <Stack direction="row" justifyContent="end">
                        {is_historico === true ? <></> :

                          <BarraDeFerramentas
                            mostrarBotaoNovo
                            textoBotaoNovo="Registar"
                            aoClicarNovo={() => {
                              setCreateTable(true)
                              onInputChange({ target: { name: "azoto_mineral", value: false } })
                              onInputChange({ target: { name: "azoto_nitrico", value: false } })
                              onInputChange({ target: { name: "azoto_total", value: false } })
                            }}
                          />}
                      </Stack>
                    </TableCell>
                  ) : (
                    createTable === true && (
                      <TableCell>
                        <ButtonCadernos
                          mostrarBotaoCancelar
                          aoClicarCancelar={() => {
                            if (flag_editado) {
                              set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                            } else {
                              handleCancel()
                            }
                          }}
                          mostrarBotaoGravar
                          aoClicarGravar={() => handleSaveAnalise()} />
                      </TableCell>
                    )
                  )}
                </TableRow>
              </TableHead>
              {rowsTableTerra.length <= 0 && createTable === true ?
                <TableBody>
                  <TableRow>
                    <StyledTableHead colSpan={2}>
                      Elemento / nutriente
                    </StyledTableHead>
                    <StyledTableHead>N<BasicPopover text={"Azoto do solo"} /></StyledTableHead>
                    <StyledTableHead>P2O5<BasicPopover text={"Fósforo do solo"} /></StyledTableHead>
                    <StyledTableHead>K2O<BasicPopover text={"Potássio do solo"} /></StyledTableHead>
                    <StyledTableHead>Mg<BasicPopover text={"Magnésio do solo"} /></StyledTableHead>
                    <StyledTableHead>
                      <CustomTextField
                        name="cabe_opcao_um"
                        value={tabelaTerra?.cabe_opcao_um === undefined ? "" : tabelaTerra.cabe_opcao_um}
                        onChange={onInputChange}
                      />
                      <BasicPopover text={"Preencher apenas quando o boletim de análises apresenta dados sobre outros elementos, que vão ser considerados na elaboração do plano de fertilização."} />
                    </StyledTableHead>
                    <StyledTableHead>
                      <CustomTextField
                        name="cabe_opcao_dois"
                        value={tabelaTerra?.cabe_opcao_dois === undefined ? "" : tabelaTerra.cabe_opcao_dois}
                        onChange={onInputChange}
                      />
                      <BasicPopover text={"Preencher apenas quando o boletim de análises apresenta dados sobre outros elementos, que vão ser considerados na elaboração do plano de fertilização."} />
                    </StyledTableHead>
                    <StyledTableHead>
                      ph(H2O)
                      <BasicPopover text={"pH do solo"} />
                    </StyledTableHead>
                    <StyledTableHead>
                      M.O.(%)
                      <BasicPopover text={"% de matéria orgânica do solo"} />
                    </StyledTableHead>
                  </TableRow>
                  <TableRow>
                    <StyledTableHead rowSpan={3}> Resultado das análises </StyledTableHead>
                    <StyledTableHead>mg/kg</StyledTableHead>
                    <StyledTableCell>
                      <CustomTextField
                        name="mg_camp1"
                        value={tabelaTerra?.mg_camp1 === undefined ? "" : tabelaTerra.mg_camp1}
                        onChange={onInputChange}
                        error={error_mg_camp1}
                        helperText={error_mg_camp1 ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="mg_camp2"
                        value={tabelaTerra?.mg_camp2 === undefined ? "" : tabelaTerra.mg_camp2}
                        onChange={onInputChange}
                        error={error_mg_camp2}
                        helperText={error_mg_camp2 ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="mg_camp3"
                        value={tabelaTerra?.mg_camp3 === undefined ? "" : tabelaTerra.mg_camp3}
                        onChange={onInputChange}
                        error={error_mg_camp3}
                        helperText={error_mg_camp3 ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="mg_camp4"
                        value={tabelaTerra?.mg_camp4 === undefined ? "" : tabelaTerra.mg_camp4}
                        onChange={onInputChange}
                        error={error_mg_camp4}
                        helperText={error_mg_camp4 ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="mg_camp5"
                        value={tabelaTerra?.mg_camp5 === undefined ? "" : tabelaTerra.mg_camp5}
                        onChange={onInputChange}
                        error={error_mg_camp5}
                        helperText={error_mg_camp5 ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="mg_camp6"
                        value={tabelaTerra?.mg_camp6 === undefined ? "" : tabelaTerra.mg_camp6}
                        onChange={onInputChange}
                        error={error_mg_camp6}
                        helperText={error_mg_camp6 ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell rowSpan={2}>
                      <CustomTextField
                        name="classe_analicesPH"
                        value={tabelaTerra?.classe_analicesPH === undefined ? "" : tabelaTerra.classe_analicesPH}
                        onChange={onInputChange}
                        error={error_Resultados_analicesPH}
                        helperText={error_Resultados_analicesPH ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell rowSpan={2}>
                      <CustomTextField
                        name="classe_analicesMO"
                        value={tabelaTerra?.classe_analicesMO === undefined ? "" : tabelaTerra.classe_analicesMO}
                        onChange={onInputChange}
                        error={error_Resultados_analicesMO}
                        helperText={error_Resultados_analicesMO ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableHead>(%)</StyledTableHead>
                    <StyledTableCell>
                      <CustomTextField
                        name="percentagem_camp1"
                        value={tabelaTerra?.percentagem_camp1 === undefined ? "" : tabelaTerra.percentagem_camp1}
                        onChange={onInputChange}
                        error={error_percentagem_camp1}
                        helperText={error_percentagem_camp1 ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="percentagem_camp2"
                        value={tabelaTerra?.percentagem_camp2 === undefined ? "" : tabelaTerra.percentagem_camp2}
                        onChange={onInputChange}
                        error={error_percentagem_camp2}
                        helperText={error_percentagem_camp2 ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="percentagem_camp3"
                        value={tabelaTerra?.percentagem_camp3 === undefined ? "" : tabelaTerra.percentagem_camp3}
                        onChange={onInputChange}
                        error={error_percentagem_camp3}
                        helperText={error_percentagem_camp3 ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="percentagem_camp4"
                        value={tabelaTerra?.percentagem_camp4 === undefined ? "" : tabelaTerra.percentagem_camp4}
                        onChange={onInputChange}
                        error={error_percentagem_camp4}
                        helperText={error_percentagem_camp4 ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="percentagem_camp5"
                        value={tabelaTerra?.percentagem_camp5 === undefined ? "" : tabelaTerra.percentagem_camp5}
                        onChange={onInputChange}
                        error={error_percentagem_camp5}
                        helperText={error_percentagem_camp5 ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="percentagem_camp6"
                        value={tabelaTerra?.percentagem_camp6 === undefined ? "" : tabelaTerra.percentagem_camp6}
                        onChange={onInputChange}
                        error={error_percentagem_camp6}
                        helperText={error_percentagem_camp6 ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableHead>Classe de fertilidade<BasicPopover text={"Registar a classe de fertilidade constante no boletim de análise para cada um dos nutrientes, caso faça parte do referido boletim."} /></StyledTableHead>

                    <StyledTableCell>
                      <CustomSelect
                        value={tabelaTerra?.classe_fertilizacao_camp1 !== undefined ? tabelaTerra?.classe_fertilizacao_camp1 : ""}
                        name="classe_fertilizacao_camp1"
                        onChange={onInputChange}
                        options={classeFertilizacao}
                        label="Classe de fertilizante"
                        minWidth={120}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomSelect
                        value={tabelaTerra?.classe_fertilizacao_camp2 !== undefined ? tabelaTerra?.classe_fertilizacao_camp2 : ""}
                        name="classe_fertilizacao_camp2"
                        onChange={onInputChange}
                        options={classeFertilizacao}
                        label="Classe de fertilizante"
                        minWidth={120}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomSelect
                        value={tabelaTerra?.classe_fertilizacao_camp3 !== undefined ? tabelaTerra?.classe_fertilizacao_camp3 : ""}
                        name="classe_fertilizacao_camp3"
                        onChange={onInputChange}
                        options={classeFertilizacao}
                        label="Classe de fertilizante"
                        minWidth={120}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomSelect
                        value={tabelaTerra?.classe_fertilizacao_camp4 !== undefined ? tabelaTerra?.classe_fertilizacao_camp4 : ""}
                        name="classe_fertilizacao_camp4"
                        onChange={onInputChange}
                        options={classeFertilizacao}
                        label="Classe de fertilizante"
                        minWidth={120}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomSelect
                        value={tabelaTerra?.classe_fertilizacao_camp5 !== undefined ? tabelaTerra?.classe_fertilizacao_camp5 : ""}
                        name="classe_fertilizacao_camp5"
                        onChange={onInputChange}
                        options={classeFertilizacao}
                        label="Classe de fertilizante"
                        minWidth={120}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomSelect
                        value={tabelaTerra?.classe_fertilizacao_camp6 !== undefined ? tabelaTerra?.classe_fertilizacao_camp6 : ""}
                        name="classe_fertilizacao_camp6"
                        onChange={onInputChange}
                        options={classeFertilizacao}
                        label="Classe de fertilizante"
                        minWidth={120}
                      />
                    </StyledTableCell>
                    <StyledTableCell
                      sx={{ backgroundColor: "lightgray" }}
                    ></StyledTableCell>
                    <StyledTableCell>
                      <CustomSelect
                        value={tabelaTerra?.classe_fertilizacao_camp7 !== undefined ? tabelaTerra?.classe_fertilizacao_camp7 : ""}
                        name="classe_fertilizacao_camp7"
                        onChange={onInputChange_editar}
                        options={classeFertilizacao}
                        label="Classe de fertilizante"
                        minWidth={120}
                      />
                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableHead colSpan={2}>
                      A deduzir no cálculo da fertilização azotada (kg/ha) <BasicPopover text={"Preenchimento referente ao elemento N (azoto)."} />
                    </StyledTableHead>
                    <StyledTableCell>
                      <CustomTextField
                        name="deduzir_cálculo"
                        value={tabelaTerra?.deduzir_cálculo === undefined ? "" : tabelaTerra.deduzir_cálculo}
                        onChange={onInputChange}
                        error={error_deduzir_cálculo}
                        helperText={error_deduzir_cálculo ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell
                      sx={{ backgroundColor: "lightgray" }} colSpan={7} >
                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={4}>
                      Quando são disponibilizados resultados analíticos referentes
                      ao teor de azoto do solo, identificar se este corresponde a:
                    </TableCell>
                    <TableCell colSpan={2}>
                      <FormControlLabel
                        name="azoto_mineral"
                        label={<Typography fontFamily="candara" fontSize={14}> Azoto mineral<BasicPopover text={"Preencher com 'X' caso seja esta a forma de azoto avaliada."} /></Typography>}
                        control={
                          <Checkbox
                            // checked={tabelaTerra?.azoto_mineral || false}
                            value={tabelaTerra?.azoto_mineral === true && tabelaTerra.azoto_mineral}
                            sx={{
                              color: "#aaaaaa",
                              "&.Mui-checked": { color: "#C94F1E", },
                            }}
                            onChange={onInputChange}
                          />

                        }
                      />

                    </TableCell>
                    <TableCell colSpan={2}>
                      <FormControlLabel
                        name="azoto_nitrico"
                        label={<Typography fontFamily="candara" fontSize={14}>Azoto nítrico<BasicPopover text={"Preencher com 'X' caso seja esta a forma de azoto avaliada."} /></Typography>}
                        control={
                          <Checkbox
                            // checked={tabelaTerra?.azoto_nitrico || false}
                            value={tabelaTerra?.azoto_nitrico === true && tabelaTerra.azoto_nitrico}
                            sx={{
                              color: "#aaaaaa",
                              "&.Mui-checked": { color: "#C94F1E", },
                            }}
                            onChange={onInputChange} />
                        }
                      />
                    </TableCell>
                    <TableCell colSpan={2}>
                      <FormControlLabel
                        name="azoto_total"
                        label={<Typography fontFamily="candara" fontSize={14}>  Azoto total<BasicPopover text={"Preencher com 'X' caso seja esta a forma de azoto avaliada."} /></Typography>}
                        control={
                          <Checkbox
                            // checked={tabelaTerra?.azoto_total || false}
                            value={tabelaTerra?.azoto_total === true && tabelaTerra.azoto_total}
                            sx={{
                              color: "#aaaaaa",
                              "&.Mui-checked": { color: "#C94F1E", },
                            }}
                            onChange={onInputChange} />
                        }
                      />
                    </TableCell>
                  </TableRow>
                </TableBody>
                :
                rowsTableTerra.length <= 0 &&
                <TableBody>
                  <TableRow>
                    <StyledTableHead colSpan={2}>
                      Elemento / nutriente
                    </StyledTableHead>
                    <StyledTableHead>N<BasicPopover text={"Azoto do solo"} /></StyledTableHead>
                    <StyledTableHead>P2O5<BasicPopover text={"Fósforo do solo"} /></StyledTableHead>
                    <StyledTableHead>K2O<BasicPopover text={"Potássio do solo"} /></StyledTableHead>
                    <StyledTableHead>Mg<BasicPopover text={"Magnésio do solo"} /></StyledTableHead>
                    <StyledTableHead sx={{ minWidth: "50%" }}><BasicPopover text={"Preencher apenas quando o boletim de análises apresenta dados sobre outros elementos, que vão ser considerados na elaboração do plano de fertilização."} /></StyledTableHead>
                    <StyledTableHead><BasicPopover text={"Preencher apenas quando o boletim de análises apresenta dados sobre outros elementos, que vão ser considerados na elaboração do plano de fertilização."} /></StyledTableHead>
                    <StyledTableHead>ph(H2O)<BasicPopover text={"pH do solo"} /></StyledTableHead>
                    <StyledTableHead>M.O.(%)<BasicPopover text={"% de matéria orgânica do solo"} /></StyledTableHead>
                  </TableRow>
                  <TableRow>
                    <StyledTableHead rowSpan={3}>    Resultado das análises   </StyledTableHead>
                    <StyledTableHead>mg/kg</StyledTableHead>
                    <StyledTableCell>  </StyledTableCell>
                    <StyledTableCell>  </StyledTableCell>
                    <StyledTableCell> </StyledTableCell>
                    <StyledTableCell> </StyledTableCell>
                    <StyledTableCell> </StyledTableCell>
                    <StyledTableCell> </StyledTableCell>
                    <StyledTableCell rowSpan={2}> </StyledTableCell>
                    <StyledTableCell rowSpan={2}> </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableHead>(%)</StyledTableHead>
                    <StyledTableCell> </StyledTableCell>
                    <StyledTableCell> </StyledTableCell>
                    <StyledTableCell>  </StyledTableCell>
                    <StyledTableCell> </StyledTableCell>
                    <StyledTableCell> </StyledTableCell>
                    <StyledTableCell> </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableHead>Classe de fertilidade<BasicPopover text={"Registar a classe de fertilidade constante no boletim de análise para cada um dos nutrientes, caso faça parte do referido boletim."} /></StyledTableHead>
                    <StyledTableCell>{/* <BasicPopover text={"Preencher campo com uma das seguintes classes: \n\nMA - Muito Alto; \nA - Alto; \nM - Médio; \nB - Baixo; \nMB - Muito Baixo."}/> */}</StyledTableCell>
                    <StyledTableCell>{/* <BasicPopover text={"Preencher campo com uma das seguintes classes: \n\nMA - Muito Alto; \nA - Alto; \nM - Médio; \nB - Baixo; \nMB - Muito Baixo."}/> */}</StyledTableCell>
                    <StyledTableCell>{/* <BasicPopover text={"Preencher campo com uma das seguintes classes: \n\nMA - Muito Alto; \nA - Alto; \nM - Médio; \nB - Baixo; \nMB - Muito Baixo."}/> */}</StyledTableCell>
                    <StyledTableCell>{/* <BasicPopover text={"Preencher campo com uma das seguintes classes: \n\nMA - Muito Alto; \nA - Alto; \nM - Médio; \nB - Baixo; \nMB - Muito Baixo."}/> */}</StyledTableCell>
                    <StyledTableCell>{/* <BasicPopover text={"Preencher campo com uma das seguintes classes: \n\nMA - Muito Alto; \nA - Alto; \nM - Médio; \nB - Baixo; \nMB - Muito Baixo."}/> */}</StyledTableCell>
                    <StyledTableCell>{/* <BasicPopover text={"Preencher campo com uma das seguintes classes: \n\nMA - Muito Alto; \nA - Alto; \nM - Médio; \nB - Baixo; \nMB - Muito Baixo."}/> */}</StyledTableCell>
                    <StyledTableCell sx={{ backgroundColor: "lightgray" }} ></StyledTableCell>
                    <StyledTableCell>{/* <BasicPopover text={"Preencher campo com uma das seguintes classes: \n\nMA - Muito Alto; \nA - Alto; \nM - Médio; \nB - Baixo; \nMB - Muito Baixo."}/> */}</StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableHead colSpan={2}>A deduzir no cálculo da fertilização azotada (kg/ha) <BasicPopover text={"Preenchimento referente ao elemento N (azoto)."} /></StyledTableHead>
                    <StyledTableCell>{/* <BasicPopover text={"Preencher campo com uma das seguintes classes: \n\nMA - Muito Alto; \nA - Alto; \nM - Médio; \nB - Baixo; \nMB - Muito Baixo."}/> */}</StyledTableCell>
                    <StyledTableCell
                      sx={{ backgroundColor: "lightgray" }} colSpan={7} >
                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={4}>
                      Quando são disponibilizados resultados analíticos referentes
                      ao teor de azoto do solo, identificar se este corresponde a:
                    </TableCell>
                    <TableCell colSpan={2}>
                      <FormControlLabel
                        label={<Typography fontFamily="candara" fontSize={14}> Azoto mineral<BasicPopover text={"Preencher com 'X' caso seja esta a forma de azoto avaliada."} /></Typography>}
                        control={
                          <Checkbox
                            sx={{
                              color: "#aaaaaa",
                              "&.Mui-checked": { color: "#C94F1E", },
                            }}
                            disabled={!createTable}
                          />
                        }
                      />
                    </TableCell>
                    <TableCell colSpan={2}>
                      <FormControlLabel
                        label={<Typography fontFamily="candara" fontSize={14}> Azoto nítrico<BasicPopover text={"Preencher com 'X' caso seja esta a forma de azoto avaliada."} /></Typography>}
                        control={
                          <Checkbox
                            sx={{
                              color: "#aaaaaa",
                              "&.Mui-checked": { color: "#C94F1E", },
                            }}
                            disabled={!createTable}
                          />
                        }
                      />
                    </TableCell>
                    <TableCell colSpan={2}>
                      <FormControlLabel
                        label={<Typography fontFamily="candara" fontSize={14}> Azoto total<BasicPopover text={"Preencher com 'X' caso seja esta a forma de azoto avaliada."} /></Typography>}
                        control={
                          <Checkbox
                            sx={{
                              color: "#aaaaaa",
                              "&.Mui-checked": { color: "#C94F1E", },
                            }}
                            disabled={!createTable}
                          />
                        }
                      />
                    </TableCell>
                  </TableRow>
                </TableBody>
              }

              {rowsTableTerra.map((table, key) => {
                return (
                  <TableBody key={key}>
                    <TableRow>
                      <TableCell
                        colSpan={9}
                        sx={{
                          fontWeight: 600,
                          textAlign: "left",
                          fontFamily: "candara",
                          fontSize: 18,
                        }}
                      >
                        Resultados das análises da Terra
                      </TableCell>
                      {rowsTableTerra.length > 0 && editRow === false ? (
                        <TableCell>
                          {is_historico === true ? <></> :

                            <ButtonCadernos
                              mostrarBotaoEditar
                              aoClicarEditar={() => handleEdit(table)}
                              mostrarBotaoApagar
                              aoClicarApagar={() =>
                                handleClickOpenDelete(table)
                              }
                            />}
                        </TableCell>
                      ) : (
                        editRow === true && (
                          <TableCell>
                            <ButtonCadernos
                              mostrarBotaoGravar
                              aoClicarGravar={() => handleUpdateAnalise()}
                              mostrarBotaoCancelar
                              aoClicarCancelar={() => {
                                if (flag_editado) {
                                  set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                } else {
                                  handleCancel()
                                }
                              }}
                            />
                          </TableCell>
                        )
                      )}
                    </TableRow>
                    {tabelaTerra?.id_registo_analise === table.id_registo_analise ?
                      <>
                        <TableRow>
                          <StyledTableHead colSpan={2}>
                            Elemento / nutriente
                          </StyledTableHead>
                          <StyledTableHead>N</StyledTableHead>
                          <StyledTableHead>P2O5</StyledTableHead>
                          <StyledTableHead>K2O</StyledTableHead>
                          <StyledTableHead>Mg</StyledTableHead>
                          <StyledTableHead>
                            <CustomTextField
                              name="cabe_opcao_um"
                              value={tabelaTerra?.cabe_opcao_um === undefined ? "" : tabelaTerra?.cabe_opcao_um}
                              onChange={onInputChange}
                            />
                          </StyledTableHead>
                          <StyledTableHead>
                            <CustomTextField
                              name="cabe_opcao_dois"
                              value={tabelaTerra?.cabe_opcao_dois === undefined ? "" : tabelaTerra?.cabe_opcao_dois}
                              onChange={onInputChange}
                            />
                          </StyledTableHead>
                          <StyledTableHead>ph(H2O)</StyledTableHead>
                          <StyledTableHead>M.O.(%)</StyledTableHead>
                        </TableRow>
                        <TableRow>
                          <StyledTableHead rowSpan={3}>
                            Resultado das análises
                          </StyledTableHead>
                          <StyledTableHead>mg/kg</StyledTableHead>
                          <StyledTableCell>
                            <CustomTextField
                              name="mg_camp1"
                              value={tabelaTerra?.mg_camp1}
                              onChange={onInputChange_editar}
                              error={error_mg_camp1}
                              helperText={error_mg_camp1 ? message_apenas_numero : ""}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="mg_camp2"
                              value={tabelaTerra?.mg_camp2}
                              onChange={onInputChange_editar}
                              error={error_mg_camp2}
                              helperText={error_mg_camp2 ? message_apenas_numero : ""}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="mg_camp3"
                              value={tabelaTerra?.mg_camp3}
                              onChange={onInputChange_editar}
                              error={error_mg_camp3}
                              helperText={error_mg_camp3 ? message_apenas_numero : ""}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="mg_camp4"
                              value={tabelaTerra?.mg_camp4}
                              onChange={onInputChange_editar}
                              error={error_mg_camp4}
                              helperText={error_mg_camp4 ? message_apenas_numero : ""}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="mg_camp5"
                              value={tabelaTerra?.mg_camp5}
                              onChange={onInputChange_editar}
                              error={error_mg_camp5}
                              helperText={error_mg_camp5 ? message_apenas_numero : ""}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="mg_camp6"
                              value={tabelaTerra?.mg_camp6}
                              onChange={onInputChange_editar}
                              error={error_mg_camp6}
                              helperText={error_mg_camp6 ? message_apenas_numero : ""}
                            />
                          </StyledTableCell>
                          <StyledTableCell rowSpan={2}>
                            <CustomTextField
                              name="classe_analicesPH"
                              value={tabelaTerra?.classe_analicesPH}
                              onChange={onInputChange_editar}
                              error={error_Resultados_analicesPH}
                              helperText={error_Resultados_analicesPH ? message_apenas_numero : ""}
                            />
                          </StyledTableCell>
                          <StyledTableCell rowSpan={2}>
                            <CustomTextField
                              name="classe_analicesMO"
                              value={tabelaTerra?.classe_analicesMO}
                              onChange={onInputChange_editar}
                              error={error_Resultados_analicesMO}
                              helperText={error_Resultados_analicesMO ? message_apenas_numero : ""}
                            />
                          </StyledTableCell>
                        </TableRow>
                        <TableRow>
                          <StyledTableHead>(%)</StyledTableHead>
                          <StyledTableCell>
                            <CustomTextField
                              name="percentagem_camp1"
                              value={tabelaTerra?.percentagem_camp1}
                              onChange={onInputChange_editar}
                              error={error_percentagem_camp1}
                              helperText={error_percentagem_camp1 ? message_apenas_numero : ""}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="percentagem_camp2"
                              value={tabelaTerra?.percentagem_camp2}
                              onChange={onInputChange_editar}
                              error={error_percentagem_camp2}
                              helperText={error_percentagem_camp2 ? message_apenas_numero : ""}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="percentagem_camp3"
                              value={tabelaTerra?.percentagem_camp3}
                              onChange={onInputChange_editar}
                              error={error_percentagem_camp3}
                              helperText={error_percentagem_camp3 ? message_apenas_numero : ""}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="percentagem_camp4"
                              value={tabelaTerra?.percentagem_camp4}
                              onChange={onInputChange_editar}
                              error={error_percentagem_camp4}
                              helperText={error_percentagem_camp4 ? message_apenas_numero : ""}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="percentagem_camp5"
                              value={tabelaTerra?.percentagem_camp5}
                              onChange={onInputChange_editar}
                              error={error_percentagem_camp5}
                              helperText={error_percentagem_camp6 ? message_apenas_numero : ""}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="percentagem_camp6"
                              value={tabelaTerra?.percentagem_camp6}
                              onChange={onInputChange_editar}
                              error={error_percentagem_camp6}
                              helperText={error_percentagem_camp6 ? message_apenas_numero : ""}
                            />
                          </StyledTableCell>
                        </TableRow>
                        <TableRow>
                          <StyledTableHead>
                            Classe de fertilidade
                          </StyledTableHead>
                          <StyledTableCell>
                            <CustomSelect
                              value={tabelaTerra?.classe_fertilizacao_camp1 || ""}
                              name="classe_fertilizacao_camp1"
                              onChange={onInputChange_editar}
                              options={classeFertilizacao}
                              label="Classe de fertilizante"
                              minWidth={120}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomSelect
                              value={tabelaTerra?.classe_fertilizacao_camp2 || ""}
                              name="classe_fertilizacao_camp2"
                              onChange={onInputChange_editar}
                              options={classeFertilizacao}
                              label="Classe de fertilizante"
                              minWidth={120}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomSelect
                              value={tabelaTerra?.classe_fertilizacao_camp3 || ""}
                              name="classe_fertilizacao_camp3"
                              onChange={onInputChange_editar}
                              options={classeFertilizacao}
                              label="Classe de fertilizante"
                              minWidth={120}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomSelect
                              value={tabelaTerra?.classe_fertilizacao_camp4 || ""}
                              name="classe_fertilizacao_camp4"
                              onChange={onInputChange_editar}
                              options={classeFertilizacao}
                              label="Classe de fertilizante"
                              minWidth={120}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomSelect
                              value={tabelaTerra?.classe_fertilizacao_camp5 || ""}
                              name="classe_fertilizacao_camp5"
                              onChange={onInputChange_editar}
                              options={classeFertilizacao}
                              label="Classe de fertilizante"
                              minWidth={120}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomSelect
                              value={tabelaTerra?.classe_fertilizacao_camp6 || ""}
                              name="classe_fertilizacao_camp6"
                              onChange={onInputChange_editar}
                              options={classeFertilizacao}
                              label="Classe de fertilizante"
                            />
                          </StyledTableCell>
                          <StyledTableCell sx={{ backgroundColor: "lightgray" }}>
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomSelect
                              value={tabelaTerra?.classe_fertilizacao_camp7 || ""}
                              name="classe_fertilizacao_camp7"
                              onChange={onInputChange_editar}
                              options={classeFertilizacao}
                              label="Classe de fertilizante"
                              minWidth={120}
                            />
                          </StyledTableCell>
                        </TableRow>
                        <TableRow>
                          <StyledTableHead colSpan={2}>
                            A deduzir no cálculo da fertilização azotada (kg/ha)
                          </StyledTableHead>
                          <StyledTableCell>
                            <CustomTextField
                              name="deduzir_cálculo"
                              value={tabelaTerra?.deduzir_cálculo}
                              onChange={onInputChange_editar}
                              error={error_deduzir_cálculo}
                              helperText={error_deduzir_cálculo ? message_apenas_numero : ""}
                            />
                          </StyledTableCell>
                          <StyledTableCell sx={{ backgroundColor: "lightgray" }} colSpan={7}>
                          </StyledTableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell colSpan={4}>
                            Quando são disponibilizados resultados analíticos
                            referentes ao teor de azoto do solo, identificar
                            se este corresponde a:
                          </TableCell>
                          <TableCell colSpan={2}>
                            <FormControlLabel
                              name="azoto_mineral"
                              label={<Typography fontFamily="candara" fontSize={14}> Azoto mineral<BasicPopover text={"Preencher com 'X' caso seja esta a forma de azoto avaliada."} /></Typography>}
                              control={
                                <Checkbox
                                  checked={tabelaTerra?.azoto_mineral || false}
                                  onChange={onInputChange_editar}

                                  sx={{
                                    color: "#aaaaaa",
                                    "&.Mui-checked": { color: "#C94F1E", },
                                  }}
                                />
                              }
                            />
                          </TableCell>
                          <TableCell colSpan={2}>
                            <FormControlLabel
                              name="azoto_nitrico"
                              label={<Typography fontFamily="candara" fontSize={14}>Azoto nítrico<BasicPopover text={"Preencher com 'X' caso seja esta a forma de azoto avaliada."} /></Typography>}
                              control={
                                <Checkbox
                                  checked={tabelaTerra?.azoto_nitrico || false}
                                  onChange={onInputChange_editar}
                                  sx={{
                                    color: "#aaaaaa",
                                    "&.Mui-checked": { color: "#C94F1E", },
                                  }}
                                />
                              }
                            />
                          </TableCell>
                          <TableCell colSpan={2}>
                            <FormControlLabel
                              name="azoto_total"
                              label={<Typography fontFamily="candara" fontSize={14}> Azoto total<BasicPopover text={"Preencher com 'X' caso seja esta a forma de azoto avaliada."} /></Typography>
                              }
                              control={
                                <Checkbox
                                  checked={tabelaTerra?.azoto_total || false}
                                  onChange={onInputChange_editar}
                                  sx={{
                                    color: "#aaaaaa",
                                    "&.Mui-checked": { color: "#C94F1E", },
                                  }}
                                />
                              }
                            />
                          </TableCell>
                        </TableRow>
                      </>
                      :
                      <>
                        <TableRow>
                          <StyledTableHead colSpan={2}> Elemento / nutriente</StyledTableHead>
                          <StyledTableHead>N<BasicPopover
                            text={" Preencher campo com uma das seguintes classes:\n\nMA - Muito Alto;\nA - Alto;\nM - Médio;\nB - Baixo;\nMB - Muito Baixo."}
                          /></StyledTableHead>
                          <StyledTableHead>P2O5<BasicPopover
                            text={" Preencher campo com uma das seguintes classes:\n\nMA - Muito Alto;\nA - Alto;\nM - Médio;\nB - Baixo;\nMB - Muito Baixo."}
                          /></StyledTableHead>
                          <StyledTableHead>K2O<BasicPopover
                            text={" Preencher campo com uma das seguintes classes:\n\nMA - Muito Alto;\nA - Alto;\nM - Médio;\nB - Baixo;\nMB - Muito Baixo."}
                          /></StyledTableHead>
                          <StyledTableHead>Mg<BasicPopover
                            text={" Preencher campo com uma das seguintes classes:\n\nMA - Muito Alto;\nA - Alto;\nM - Médio;\nB - Baixo;\nMB - Muito Baixo."}
                          /></StyledTableHead>
                          <StyledTableHead>{table.cabe_opcao_um}<BasicPopover
                            text={" Preencher campo com uma das seguintes classes:\n\nMA - Muito Alto;\nA - Alto;\nM - Médio;\nB - Baixo;\nMB - Muito Baixo."}
                          /></StyledTableHead>
                          <StyledTableHead>{table.cabe_opcao_dois}<BasicPopover
                            text={" Preencher campo com uma das seguintes classes:\n\nMA - Muito Alto;\nA - Alto;\nM - Médio;\nB - Baixo;\nMB - Muito Baixo."}
                          /></StyledTableHead>
                          <StyledTableHead>ph(H2O)<BasicPopover
                            text={" Preencher campo com uma das seguintes classes:\n\nMA - Muito Alto;\nA - Alto;\nM - Médio;\nB - Baixo;\nMB - Muito Baixo."}
                          /></StyledTableHead>
                          <StyledTableHead>M.O.(%)<BasicPopover
                            text={" Preencher campo com uma das seguintes classes:\n\nMA - Muito Alto;\nA - Alto;\nM - Médio;\nB - Baixo;\nMB - Muito Baixo."}
                          /></StyledTableHead>
                        </TableRow>
                        <TableRow>
                          <StyledTableHead rowSpan={3}>   Resultado das análises  </StyledTableHead>
                          <StyledTableHead>mg/kg</StyledTableHead>
                          <StyledTableCell> {table.mg_camp1} </StyledTableCell>
                          <StyledTableCell> {table.mg_camp2}   </StyledTableCell>
                          <StyledTableCell> {table.mg_camp3}</StyledTableCell>
                          <StyledTableCell> {table.mg_camp4}  </StyledTableCell>
                          <StyledTableCell> {table.mg_camp5} </StyledTableCell>
                          <StyledTableCell> {table.mg_camp6}  </StyledTableCell>
                          <StyledTableCell rowSpan={2}> {table.classe_analicesPH}  </StyledTableCell>
                          <StyledTableCell rowSpan={2}>{table.classe_analicesMO} </StyledTableCell>
                        </TableRow>
                        <TableRow>
                          <StyledTableHead>(%)</StyledTableHead>
                          <StyledTableCell> {table.percentagem_camp1} </StyledTableCell>
                          <StyledTableCell> {table.percentagem_camp2} </StyledTableCell>
                          <StyledTableCell> {table.percentagem_camp3} </StyledTableCell>
                          <StyledTableCell> {table.percentagem_camp4}  </StyledTableCell>
                          <StyledTableCell> {table.percentagem_camp5} </StyledTableCell>
                          <StyledTableCell> {table.percentagem_camp6}</StyledTableCell>
                        </TableRow>
                        <TableRow>
                          <StyledTableHead>
                            <Stack direction="row" justifyContent="center" alignItems="center">
                              Classe de fertilidade
                              <BasicPopover
                                text={"Registar a classe de fertilidade constante no boletim de análise para cada um dos nutrientes, caso faça parte do referido boletim."}
                              />
                            </Stack>
                          </StyledTableHead>
                          <StyledTableCell>
                            <Stack direction="row" justifyContent="center" alignItems="center">
                              {table.classe_fertilizacao_camp1}

                            </Stack>
                          </StyledTableCell>
                          <StyledTableCell>
                            <Stack direction="row" justifyContent="center" alignItems="center">
                              {table.classe_fertilizacao_camp2}

                            </Stack>
                          </StyledTableCell>
                          <StyledTableCell>
                            <Stack direction="row" justifyContent="center" alignItems="center">
                              {table.classe_fertilizacao_camp3}

                            </Stack>
                          </StyledTableCell>
                          <StyledTableCell>
                            <Stack direction="row" justifyContent="center" alignItems="center">
                              {table.classe_fertilizacao_camp4}

                            </Stack>
                          </StyledTableCell>
                          <StyledTableCell>
                            <Stack direction="row" justifyContent="center" alignItems="center">
                              {table.classe_fertilizacao_camp5}

                            </Stack>
                          </StyledTableCell>
                          <StyledTableCell>
                            <Stack direction="row" justifyContent="center" alignItems="center">
                              {table.classe_fertilizacao_camp6}

                            </Stack>
                          </StyledTableCell>
                          <StyledTableCell
                            sx={{ backgroundColor: "lightgrey" }}
                          ></StyledTableCell>
                          <StyledTableCell>
                            <Stack direction="row" justifyContent="center" alignItems="center">
                              {table.classe_fertilizacao_camp7}

                            </Stack>
                          </StyledTableCell>
                        </TableRow>
                        <TableRow>
                          <StyledTableHead colSpan={2}>
                            <Stack direction="row" justifyContent="right" alignItems="center">
                              A deduzir no cálculo da fertilização azotada (kg/ha)
                              <BasicPopover
                                text={"  Preenchimento referente ao elemento N (azoto)."}
                              />
                            </Stack>
                          </StyledTableHead>
                          <StyledTableCell>
                            {table.deduzir_cálculo}
                          </StyledTableCell>
                          <StyledTableCell
                            colSpan={7} sx={{ backgroundColor: "lightgrey" }}
                          ></StyledTableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell colSpan={4}>
                            Quando são disponibilizados resultados analíticos referentes ao teor de azoto do solo, identificar se este corresponde a:
                          </TableCell>
                          <TableCell colSpan={2}>
                            <FormControlLabel
                              sx={{ paddingLeft: 8 }}
                              label={<Typography fontFamily="candara" fontSize={14} > Azoto mineral<BasicPopover text={"Preencher com 'X' caso seja esta a forma de azoto avaliada."} /></Typography>
                              }
                              aria-readonly
                              control={
                                <Checkbox
                                  checked={table.azoto_mineral}
                                  sx={{
                                    color: "#aaaaaa",
                                    "&.Mui-checked": { color: "#C94F1E", },
                                  }}
                                  disabled={!createTable}
                                />
                              }
                            />
                          </TableCell>
                          <TableCell colSpan={2}>
                            <FormControlLabel
                              sx={{ paddingLeft: 8 }}
                              label={<Typography fontFamily="candara" fontSize={14} > Azoto nítrico<BasicPopover text={"Preencher com 'X' caso seja esta a forma de azoto avaliada."} /></Typography>
                              }
                              aria-readonly
                              control={
                                <Checkbox
                                  checked={table.azoto_nitrico}
                                  sx={{
                                    color: "#aaaaaa",
                                    "&.Mui-checked": { color: "#C94F1E", },
                                  }}
                                  disabled={!createTable}
                                />
                              }
                            />
                          </TableCell>
                          <TableCell colSpan={2}>
                            <FormControlLabel sx={{ paddingLeft: 8 }}
                              label={<Typography fontFamily="candara" fontSize={14} >Azoto total<BasicPopover text={"Preencher com 'X' caso seja esta a forma de azoto avaliada."} /></Typography>}
                              aria-readonly
                              control={
                                <Checkbox
                                  checked={table.azoto_total}
                                  sx={{
                                    color: "#aaaaaa",
                                    "&.Mui-checked": { color: "#C94F1E", },
                                  }}

                                  disabled={!createTable}
                                />
                              }
                            />
                          </TableCell>
                        </TableRow>
                      </>
                    }

                  </TableBody>
                );
              })}
            </table>
          </TableContainer>
        </CustomThemeProvider>
      )}
      <ConfirmDialog
        open={openDeleteAnalise}
        onClose={() => setOpenDeleteAnalise(false)}
        onConfirm={handleDeleteAnalise}
        message="Deseja eliminar o registo?"
      />
      <ConfirmDialog
        open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
        onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
        onConfirm={() => handleCloseDialog()}
        message={mensagem_tem_a_certeza_de_apagar_alteracoes}
      />
    </>
  );
};
